import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { SampleDetailsPage } from './sample-details.page';

const routes: Routes = [
  {
    path: '',
    component: SampleDetailsPage
  }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SampleDetailsPageRoutingModule {}
